import { useEffect, useRef } from "react";
import { useUserData } from "../hooks/use-user-data";
import { identifyPostHogUser } from "../utils/posthog";

export const PostHogUserIdentifier = () => {
  const { user } = useUserData();
  const identifiedUserId = useRef<number | undefined>(undefined);

  useEffect(() => {
    if (!user || identifiedUserId.current === user.id) return;
    identifyPostHogUser(user);
    identifiedUserId.current = user.id;
  }, [user]);

  return undefined;
};
